export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-1.c38aa641.png";